import { render, staticRenderFns } from "./student.vue?vue&type=template&id=2f778af6&scoped=true"
import script from "./student.vue?vue&type=script&lang=js"
export * from "./student.vue?vue&type=script&lang=js"
import style0 from "./student.vue?vue&type=style&index=0&id=2f778af6&prod&lang=scss&scoped=true"
import style1 from "./student.vue?vue&type=style&index=1&id=2f778af6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f778af6",
  null
  
)

export default component.exports